import type { ProviderDepartment } from "@src/interfaces/provider.interface";
import { SelectInput } from "@uhg-abyss/web/ui/SelectInput";
import type { FC } from "react";

export const ALL_LOCATIONS_VALUE = "all";

interface LocationOption {
  value: string;
  label: string;
}

interface LocationFilterProps {
  departments: ProviderDepartment[];
  selectedDepartmentId: string;
  onChange: (departmentId: string) => void;
}

const buildLocationOptions = (departments: ProviderDepartment[]): LocationOption[] => {
  const seen = new Set<number>();
  const unique: LocationOption[] = [];

  for (const dept of departments) {
    if (!seen.has(dept.department_id)) {
      seen.add(dept.department_id);
      const locationPart = [dept.address_line_1, dept.city].filter(Boolean).join(", ");
      unique.push({ value: String(dept.department_id), label: locationPart });
    }
  }

  return [{ value: ALL_LOCATIONS_VALUE, label: "All locations" }, ...unique];
};

export const LocationFilter: FC<LocationFilterProps> = ({
  departments,
  selectedDepartmentId,
  onChange,
}) => {
  const options = buildLocationOptions(departments);

  return (
    <SelectInput
      data-testid="test-id-meet-the-team-location-select"
      id="obc-meet-the-team-location-filter"
      data-id="obc-meet-the-team-location-filter"
      data-obc-label="Meet the Team Location Filter"
      label="Location"
      options={options}
      value={selectedDepartmentId}
      onChange={(val: string) => onChange(val)}
      css={{
        "abyss-select-input-root": {
          width: "100%",
          maxWidth: "260px",
        },
      }}
    />
  );
};
